<template>
  <div>
    <md-field>
      <label><slot></slot></label>
      <md-input v-model="pw"></md-input>
    </md-field>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    onSuccess: Function,
    password: String
  },
  data() {
    return {
      pw: ""
    };
  },
  watch: {
    pw(val) {
      if (val == this.password) {
        this.onSuccess();
      }
    }
  },
  methods: {},
  mounted() {},
  computed: {}
};
</script>
<style lang="sass" scoped></style>
